import { render, staticRenderFns } from "./guanliyuan.vue?vue&type=template&id=c938aa9c&scoped=true&"
import script from "./guanliyuan.vue?vue&type=script&lang=js&"
export * from "./guanliyuan.vue?vue&type=script&lang=js&"
import style0 from "./guanliyuan.vue?vue&type=style&index=0&id=c938aa9c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c938aa9c",
  null
  
)

export default component.exports